import { API } from "@swivl-mono/api-helper";
import { warn } from "@swivl-mono/helpers";
import { TopicVersioTopics, TopicVersionsPayload } from "@swivl-mono/types";
import { parse } from "path";

import { Member } from "../Member/Member.Current";
import { UsersModel } from "../Users/Users.Model";

const INTERVAL_IN_SECONDS = 15;
export class TopicVersionsManager {
  static topicVersions: TopicVersionsPayload | null = null;
  static timer: NodeJS.Timer | null = null;
  static startPeriodicCheckForTopicVersionChanges(skipInitialCheck: boolean = false) {
    if (!skipInitialCheck) {
      this.checkForUpdatedTopicVersionsAndRefreshIfNeeded(false);
    }
    console.log("Starting periodic check for topic version changes");
    if (this.timer) {
      return; // Already started
    }
    this.timer = setInterval(() => {
      this.checkForUpdatedTopicVersionsAndRefreshIfNeeded();
    }, 1000 * INTERVAL_IN_SECONDS); // Check every 30 seconds
  }

  static async checkForUpdatedTopicVersionsAndRefreshIfNeeded(resetTimer: boolean = false) {
    if (resetTimer && this.timer) {
      clearInterval(this.timer);
      this.timer = null;
      this.startPeriodicCheckForTopicVersionChanges(true);
    }
    if (Member.orgId === undefined) {
      return;
    }
    const fetchedVersions = await API.TopicsVersions.getTopicVersions(Member.orgId);
    if (!fetchedVersions) {
      warn("Failed to fetch topic versions");
      return;
    }
    console.log("topic loadTopicVersions :", this.topicVersions, fetchedVersions);

    if (!this.topicVersions) {
      this.topicVersions = fetchedVersions;
      return;
    }
    // Check to see if there is a difference
    for (const [key, value] of Object.entries(fetchedVersions)) {
      if (this.topicVersions[key] !== value) {
        let current = this.topicVersions[key] ? this.topicVersions[key].version : 0;
        let fetched = value ? value.version : 0;
        console.log(`topic versions ${key}: ${current} -> ${fetched}`);
        // There is a change, mark that we need to refresh active data

        if (fetched > current) {
          const updatedAt = new Date(value.updatedAt);
          // Check to see if it was updated withing 3 seconds, if so ignore becuase we may still get it via we sockets.
          if (updatedAt && new Date().getTime() - updatedAt.getTime() < 3000) {
            console.log("Ignoring session topic version change, updated too recently", key, value, updatedAt, typeof updatedAt);
            continue;
          }
          console.log("Session topic version changed, should refresh active sessions", key, value, updatedAt, typeof updatedAt);
          // UsersModel.shouldRefreshActive = true;
          this.topicVersions = fetchedVersions;

          UsersModel.loadAll();
          return;
        }
        // if (key === TopicVersioTopics.ESCALATION && fetched > current) {
        //   const updatedAt = new Date(value.updatedAt);

        //   console.log("Escalation topic version changed, should refresh active escalations", key, value);
        //   if (updatedAt && new Date().getTime() - updatedAt.getTime() < 3000) {
        //     console.log("Ignoring session topic version change, updated too recently", key, value, updatedAt, typeof updatedAt);
        //     continue;
        //   }

        //   // UsersModel.shouldRefreshActive = true;
        // }
      }
    }
    this.topicVersions = fetchedVersions;
    return;
  }
}
